/* eslint-disable no-unused-expressions */
export default class Queue {
  queue;
  _limit;
  constructor(arg) {
    // TODO: config 로 세팅 할수있게 변경
    this._limit = arg?.limit ?? 4;
    this.queue = [];
  }

  enqueue(image) {
    if (this.size >= this._limit) this.dequeue();
    this.queue.push(image);
  }

  dequeue() {
    if (this.queue.length) return this.queue.shift();
  }

  reset() {
    this.queue = [];
  }

  takeFirst() {
    if (this.size) return this.queue[0];
  }

  takeAll() {
    return this.queue;
  }

  takeLast(size) {
    const { length } = this.queue;
    return this.queue.slice(length - size, length);
  }

  peek(index) {
    this.queue[index];
  }

  get limit() {
    return this._limit;
  }

  get isEmpty() {
    return !this.queue.length;
  }

  get size() {
    return this.queue.length;
  }
}
